import { useMemo } from 'react';
import { uniqBy, uniq, isNil } from 'mojito/utils';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import PrebuiltBetView from 'modules/prebuilt-bets/prebuilt-bet/view/index.js';

const AnalyticsTypes = MojitoServices.Analytics.types;
const { FlexPane, Text } = MojitoPresentation.Components;
const { PREBUILT_ACCA } = AnalyticsTypes.SELECTION_TYPE;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;
const AnalyticsContextBuilder = MojitoCore.Presentation.AnalyticsContext.ContextBuilder;
const analyticsContext = new AnalyticsContextBuilder().withAnalyticsPath(PREBUILT_ACCA).build();

const PrebuiltAcca = props => {
    const {
        mojitoTools: { config },
        market,
        event,
        promotionText,
        onEventClick,
    } = props;

    const parts = market?.preBuiltBetBuilderParts;

    const isSameMarketBet =
        parts?.length &&
        parts.every(part => !isNil(part.marketType)) &&
        uniqBy(parts, part => part.marketType).length === 1;

    // We will find out if all parts belong to the same market type and have the same marketName (excluding participant).
    // If so, we will display the unique marketName as subheader as it will be common for all parts.
    // Typically, this is not the best idea to parse content strings, but in this case, we have no other alternatives.
    const subHeader = useMemo(() => {
        if (isSameMarketBet) {
            const marketNames = parts.map(part =>
                omitParticipantName(part.marketName, part.eventName)
            );
            return uniq(marketNames).length === 1 ? marketNames[0] : undefined;
        }
    }, [isSameMarketBet, parts]);
    const hasPromotionText = Boolean(promotionText);

    return (
        <AnalyticsContextExtender value={analyticsContext} pathSeparator={'_'} pathReverse={true}>
            <PrebuiltBetView
                config={config.view}
                market={market}
                event={event}
                showMarketName={!subHeader}
                onEventClick={onEventClick}
                class={'ta-PrebuiltAcca'}
            >
                {config.view.showCardHeader && (
                    <FlexPane class="ta-header" config={config.headerContainer}>
                        <FlexPane config={config.headerTextContainer}>
                            {hasPromotionText && (
                                <Text class={'ta-promotionText'} config={config.promotionText}>
                                    {promotionText}
                                </Text>
                            )}
                            {subHeader && (
                                <Text class={'ta-subHeaderText'} config={config.marketName}>
                                    {subHeader}
                                </Text>
                            )}
                        </FlexPane>
                    </FlexPane>
                )}
            </PrebuiltBetView>
        </AnalyticsContextExtender>
    );
};

const omitParticipantName = (marketName, eventName) => {
    const participants = eventName.split(/ v | @ /);
    const participantInMarket = participants.find(participant => marketName.includes(participant));
    return participantInMarket ? marketName.replace(participantInMarket, '').trim() : marketName;
};

export default PrebuiltAcca;
